var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navigation-wrapper"},[_c('div',{staticClass:"navigation"},[_c('profile-nav-bar-links',{attrs:{"profile-routes":_vm.profileRoutes,"disabled-routes":_vm.disabledRoutes}}),_c('profile-nav-bar-log-out'),_c('profile-nav-bar-settings')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }